import type { MapLayer } from "~/components/map/registry/mapLayer";
import {
  type MapLayerId,
  RESTRICTION_LAYER_REGISTRY,
} from "~/routes/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/-components/restrictionsLayersConfig";

export function restrictionPropertyLayer(id: MapLayerId): MapLayer {
  const layer = RESTRICTION_LAYER_REGISTRY.layers.find(
    (entry) => entry.id === id,
  );
  if (!layer) throw new Error(`Unknown restriction ${id}`);
  return layer;
}
